export default class BlockLink {
  constructor(blockClass = 'block-link') {
    this.blockClass = blockClass;
  }

  init() {
    document
      .querySelectorAll(`.${this.blockClass}`)
      .forEach((blockListElement) => {
        const anchorElement = blockListElement.querySelector('a');
        const imageElement = blockListElement.querySelector('img');

        if (!anchorElement || !imageElement) return;

        blockListElement.addEventListener('click', () =>
          this.handleClickOnBlock(anchorElement)
        );
      });
  }

  handleClickOnBlock(anchorElement) {
    const isTextSelected = window.getSelection().toString();
    if (!isTextSelected) anchorElement.click();
  }
}
